<template lang="pug">
.brief
  .brief__table
    el-table( :data="data" )
      el-table-column(
        :render-header="renderHeader"
        width="320"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          div(style="display: flex; align-items: center")
            i.iconfont.icon-r(style="color: #3370d2; margin-right: 5px" v-if="scope.row.is_storage")
            span {{ scope.row.vendor_name_ch }}/{{scope.row.vendor_name}}
      el-table-column(
        :label="$t('联系人')"
        prop="selectUser.user_name"
        align="left"
      )
      el-table-column(
        :label="$t('状态')",
        align="left",
        show-overflow-tooltip
      )
        template(
          slot-scope="scope"
          v-if="scope.row.selectUser"
        )
          span(
            v-if="scope.row.selectUser.status === 1"
            style="color: green"
          ) {{ $t('下发成功') }}
          span(v-else-if="scope.row.selectUser.status === 2")
            span(style="color: red") {{ $t('下发失败') }}
            span(style="color: #00a0e5; cursor: pointer; marginLeft: 10px") {{ $t('点击重试') }}
          span(v-else-if="scope.row.selectUser.status === 3") {{ $t('已拒绝') }}
          span(v-else) {{ $t('待下发') }}
      el-table-column(
        :label="$t('下发时间')"
        align="left"
      )
       template(slot-scope="scope")
        span(v-if="scope.row.selectUser.status === 3") —
        span(v-else) {{ scope.row.selectUser.deliver_date | dateFormatter }}
      el-table-column(
        :label="$t('推荐方')"
        align="left"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ scope.row.recommend_resource.split(',').map(o => $t(o)).join(',') }}
</template>

<script>
import { dateFormatter } from '@/umcc/util'

export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  filters: {
    dateFormatter
  },
  data () {
    return {
      selectedList: []
    }
  },
  methods: {
    renderHeader (h, { column, $index }) {
      return (<span>
        <span style="fontWeight: 400; cursor: pointer; margin-right: 5px">
          {this.$t('供应商')}
        </span>
        <el-tooltip content={this.$t('R 标识核心供应商类型')} placement="top" style="margin-left: '5px'">
          <i class="el-icon-question"/>
        </el-tooltip>
      </span>)
    }
  }
}
</script>

<style lang="stylus">
.brief__brief
  > span:nth-child(1)
    margin-right 10px
  > span:nth-child(2)
    color: #00a0e5
    cursor pointer
</style>
